module.exports = __webpack_public_path__ + "img/overview_people.dac3b7ba.png";